<template lang="pug">
section singlerooms
</template>

<script>
  export default {};
</script>

<style lang="scss"></style>
